import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from '../../../shared/services/login.service';
import { GlobalService } from '../../../shared/services/global.service';

@Component({
    selector: 'app-validate',
    templateUrl: './validate.component.html',
    styleUrls: ['./validate.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValidateComponent implements OnInit {
	token: any = null;
	get_session() {
		this._lS.validateSesion(this.token).subscribe(
			(data: any) => {
				if (data.access == 'Session Active') {
					this._gS.setSession(data.token);
					this._gS.user = data.user;
					sessionStorage.setItem('pms_us', JSON.stringify(data.user));
					// this._gS.accesKey = data.fs_key;
					// this._gS.secret = data.fs_sec;
					// this._gS.bucket = data.fs_buk;
					let route ='/home';
					route = route ? route : '/home';
					this.router.navigateByUrl(route);
				} else {
					this.router.navigate(['/login']);
				}
			}
		)
	}

	constructor(private _cS: CookieService, private _lS: LoginService, public _gS: GlobalService, private router: Router) { }

  ngOnInit() {
		this.get_session();
	}

}
